var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('kitchen-form',{staticClass:"mb-4",attrs:{"creating":_vm.creating,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }